import { render } from "./nav-item.vue?vue&type=template&id=ef07cf7a"
import script from "./nav-item.vue?vue&type=script&lang=js"
export * from "./nav-item.vue?vue&type=script&lang=js"

import "./nav-item.vue?vue&type=style&index=0&id=ef07cf7a&lang=less"

import exportComponent from "F:\\code\\suplasercut\\suplasercut-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__